import styled from "styled-components";
import { theme } from "@octane/spark";

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 0 5px 0;
    gap: 5px;

    height: 30px;

    /* Inside auto layout */
    flex: none;
    order: 18;
    flex-grow: 0;

    margin: 0 auto;

    font-weight: 700 !important;
`;

export const Line = styled.div`
    width: 66px;
    height: 1px;
    background: ${theme.colors.monochrome.concrete};

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 1;
`;
